// extracted by mini-css-extract-plugin
module.exports = {"embed":"Embed_embed__1x7WP"};